module.exports = __webpack_public_path__ + "static/media/danny_chen_2022.cf8f9bbf.png";